import React from "react";
import styled from "styled-components";

export default () => {
  const echoVRDefinitions = (
    <defs>
      <linearGradient
        x1="56.908771%"
        y1="47.2480464%"
        x2="50%"
        y2="50%"
        id="echovr-linearGradient-1"
      >
        <stop stopColor="#BBE3FC" stopOpacity="0.9" offset="0%" />
        <stop stopColor="#CCE9FD" stopOpacity="0.77" offset="64.973294%" />
        <stop stopColor="#BBE1FC" stopOpacity="0.579766757" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="44.8382772%"
        y1="55.2896649%"
        x2="-7.14014459%"
        y2="60.04325%"
        id="echovr-linearGradient-2"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0.65" offset="0%" />
        <stop stopColor="#000000" stopOpacity="0.108808877" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="100%"
        y1="47.7666498%"
        x2="0%"
        y2="39.6748353%"
        id="echovr-linearGradient-3"
      >
        <stop stopColor="#FEFEFE" offset="0%" />
        <stop stopColor="#A5CFE4" offset="100%" />
      </linearGradient>
      <path
        d="M88.4715245,1.11524836 C87.3990525,1.73416214 85.7654758,3.8546965 89.2193438,10.1399366 C92.6732119,16.4251768 94.8101284,17.0997195 95.8497753,16.5449976 C96.8894223,15.9902757 101.868082,15.0832797 97.0389946,6.153183 C92.2099067,-2.77691367 89.5439965,0.496334578 88.4715245,1.11524836 Z"
        id="echovr-path-4"
      />
      <linearGradient
        x1="50%"
        y1="100%"
        x2="50%"
        y2="3.061617e-15%"
        id="echovr-linearGradient-5"
      >
        <stop stopColor="#F0F8FC" stopOpacity="0.94" offset="0%" />
        <stop stopColor="#BBE1FE" stopOpacity="0.82" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="44.8382772%"
        y1="55.2896649%"
        x2="-61.7672471%"
        y2="62.4380296%"
        id="echovr-linearGradient-6"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0.62" offset="0%" />
        <stop stopColor="#000000" stopOpacity="0.108808877" offset="100%" />
      </linearGradient>
      <path
        d="M1.78735826,38.6133113 C0.253606922,39.0953149 -0.538293355,41.1052178 1.41764042,47.9703581 C3.3735742,54.8354984 5.39771544,55.560642 6.60107369,55.2543505 C7.80443194,54.9480589 10.2357212,53.2364714 8.06512896,45.771463 C5.89453674,38.3064547 3.3211096,38.1313078 1.78735826,38.6133113 Z"
        id="echovr-path-7"
      />
    </defs>
  );

  const echoVR = (
    <g id="EchoVR_Vas" transform="translate(286.755575, 208.312741)">
      {echoVRDefinitions}
      <g id="echoVRRightFace" style={{ opacity: 0 }}>
        <use fill="url(#echovr-linearGradient-1)" xlinkHref="#echovr-path-4" />
        <use
          stroke="url(#echovr-linearGradient-3)"
          strokeWidth="0.5"
          fillOpacity="0.19"
          fill="url(#echovr-linearGradient-2)"
          xlinkHref="#echovr-path-4"
        />
      </g>
      <path
        d="M93.6525137,8.01029601 C81.4920374,14.5798818 67.8153494,21.3567684 52.6224499,28.3409556 C37.4295504,35.3251429 21.2232565,41.5857351 4.00356824,47.1227324"
        id="echoVRFluid"
        stroke="url(#echovr-linearGradient-5)"
        strokeWidth="17.5"
        style={{ strokeDashoffset: "-97.9504px" }}
      />
      <g id="echoVRLeftFace" style={{ opacity: 0 }}>
        <g
          style={{
            transform: "translateX(-4.5px) translateY(-46.5px)"
          }}
        >
          <use fill="#ACDDF6" xlinkHref="#echovr-path-7" />
          <use
            stroke="url(#echovr-linearGradient-3)"
            strokeWidth="0.5"
            fillOpacity="0.390000015"
            fill="url(#echovr-linearGradient-6)"
            xlinkHref="#echovr-path-7"
          />
        </g>
      </g>
    </g>
  );

  return (
    <svg>
      {echoVR}
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/VasDeferenceEchoVR.js